import {Component, OnDestroy, OnInit} from "@angular/core";
import {SessionService} from "src/app/services/session.service";
import {UserHttpClientService} from "../../../data/user-http-client.service";
import {User} from "../../../models/User/user";
import {Subscription} from "rxjs/internal/Subscription";
import { SetTitleService } from "src/app/services/set-title.service";


@Component({
    templateUrl: "./main-profile.component.html"
})
export class MainProfileComponent implements OnInit, OnDestroy {
    userInfo: User;
    walletIds = [] as string[];

    isAuthorized = true;

    userInfo$ = new Subscription();
    walletInfo$ = new Subscription();

    constructor(
        private session: SessionService,
        private userService: UserHttpClientService,
        private settitleservice : SetTitleService
    ) {
        this.userInfo = {} as User;
    }

    ngOnInit() {
        if (this.session.isLoggedIn()) {
            this.userInfo$ = this.userService.getUserDetails().subscribe((user: User) => {
                this.userInfo = user;
                this.isAuthorized = user.is_authorized;
            });

            this.walletInfo$ = this.userService.getUserWallets().subscribe(
                {
                    next: wallets => {
                        for (const wallet of wallets) {
                            this.walletIds.push(wallet.walletId.toString());
                        }
                    }
                }
            );
            this.settitleservice.sendTitle("My Profile");
        }
    }

    ngOnDestroy() {
        this.userInfo$.unsubscribe();
        this.walletInfo$.unsubscribe();
    }
}
